import $ from 'jquery'
import Flickity from 'flickity'
import { fixMobileSwipe } from './patches/FlickityPatch'

export default () => {
    $(window).on('resize', () => {
        initSpecialismSlider()
    }).resize()
}

function initSpecialismSlider () {

    let $sliderElement = $('body .specialisations.slider .specialisations-holder')
    let slide = $sliderElement.find('.card-special')

    let options = {
        cellSelector: '.card-special',
        pageDots: false,
        contain: true,
        prevNextButtons: true,
        adaptiveHeight: false,
        autoPlay: false,
        wrapAround: true,
        cellAlign: 'center',
        groupCells: false,
        draggable: '>1',
        imagesLoaded: true,
    }

    if (slide.length <= 0) {
        return
    }

    let flkty = new Flickity($sliderElement.get(0), options)

    fixMobileSwipe($sliderElement)
}
